<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Tilbakehold</h2>
    </v-flex>
    <v-flex xs12>
      <BooleanInput v-model="stepValues.bool.first" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <div v-if="!stepValues.bool.first.depositReturn.value">
      <v-flex xs12 class="mb-3">
        <v-card flat>
          <v-card-text>
            <v-flex xs12 class="text-center">
              <BooleanInput v-model="stepValues.bool.second" @update-fields="updateFields"></BooleanInput>
              <h4
                v-if="stepValues.bool.second.agreement.value"
              >Partene er enige om tilbakehold på kr</h4>
              <h4 v-else>Partene er uenige om oppgjøret. Kjøper krever tilbakehold på kr:</h4>
              <TextInput v-model="stepValues.textInputs" @update-fields="updateFields"></TextInput>
              <TextareaInput v-model="stepValues.textAreaInputs" @update-fields="updateFields"></TextareaInput>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  computed: {
    finished: function() {
      if (!this.stepValues.bool.first.depositReturn.value) {
        if (!Boolean(this.stepValues.textInputs.sum.value)) {
          this.$emit("error", "Feltet med beløp må fylles ut");
          return false;
        }
      }
      return true;
    }
  }
};
</script>
